import useCampaignsData from "@/modules/common/hooks/campaigns-data.hook";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { UUID } from "crypto";
import { useContext, useState, type SyntheticEvent } from "react";

const useEditAdset = () => {
  const { lead } = useContext(LeadPageContext);
  const [editAdsetModalOpen, setEditAdsetModalOpen] = useState(false);
  const [adset, setAdset] = useState<{
    label: string;
    uid: UUID | string;
  } | null>(null);

  const handleChangeAdset = (
    _event: SyntheticEvent<Element, Event>,
    value: { label: string; uid: UUID | string } | null
  ) => {
    setAdset(value || null);
  };
  const { Adsets } = useCampaignsData();
  return {
    adset: {
      editAdsetModalOpen,
      setEditAdsetModalOpen,
      handleChangeAdset,
      state: adset,
      AdsetsData: Adsets,
      setState: setAdset,
      value: lead?.data?.lead?.adset?.name,
    },
  };
};

export default useEditAdset;
